import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";

export const determineCashDownOptions = (maxDownPayment, currentCash, noCar, currentCarLoanAmt,
        tradeInAmt, newCarLoanAmt, newCarLoanAmtOriginal) => {
    let cashDownOptionsArr = [];
    let value = 5000;
    let selection = "";
    let adjustedMaxDownPayment = +maxDownPayment;
    if (+maxDownPayment > +currentCash){
        adjustedMaxDownPayment = +currentCash;
    }
    while (value < adjustedMaxDownPayment){
        if (noCar === true){
            selection =  "Apply " + doubleToStringMonthly(value) + " To Current Car Loan";
        }else{
            selection = "Put " + doubleToStringMonthly(value) + " Down on the car";
        }
        const cashDownObj = {value: value, selection: selection};
        cashDownOptionsArr.push(cashDownObj);
        value += 5000; 
    }
    if (currentCarLoanAmt > 0 &&
        +currentCash > currentCarLoanAmt &&
        +currentCarLoanAmt > tradeInAmt){
            value = +currentCarLoanAmt - +tradeInAmt;
            selection = "Pay Off the Current Car Loan Balance";
            value += 5000;  
            const cashDownObj = {value: value, selection: selection};
            cashDownOptionsArr.push(cashDownObj);
            //  the following confirms there is enough cash to pay off current loan
            //  and buy the new car (no loan required)
            if (+adjustedMaxDownPayment >= +maxDownPayment && noCar === false){
                value = +maxDownPayment;
                selection = "Pay Off Current Car Loan and Pay For New Car";
                value += 5000;  
                const cashDownObj = {value: value, selection: selection};
                cashDownOptionsArr.push(cashDownObj);
            }
    }else{
        if (noCar === false){
            if (+currentCash > +newCarLoanAmt &&
                currentCarLoanAmt === 0){
                value = +newCarLoanAmtOriginal;
                selection = "Pay Full Amount of New Car (no loan)";
                const cashDownObj = {value: value, selection: selection};
                cashDownOptionsArr.push(cashDownObj);
            }
        }
    }
    if (cashDownOptionsArr.length > 0){
        const cashDownObj = {value: 0, selection: "no cash payment amount"};
        cashDownOptionsArr.unshift(cashDownObj);
    }
    return cashDownOptionsArr;
}

export default determineCashDownOptions;